import API from './index';

const api = {
    getReportDetail({ params }) {
        return API.authAPI({
            url: '/approval/get-report-detail',
            method: 'GET',
            params: { ...params },
        });
    },
    saveSusar(data) {
        return API.authAPI({
            url: '/approval/save-susar',
            method: 'POST',
            data,
        });
    },
    submitSusar(data) {
        return API.authAPI({
            url: '/approval/submit-susar',
            method: 'POST',
            data,
        });
    },
    downloadDocument(data) {
        return API.authAPI({
            url: `/approval/download-supplementary/${data.id}`,
            method: 'GET',
            responseType: 'blob',
            timeout: 1000 * 60 * 10,
        });
    },
};

export default api;
